module.exports = require("live/components/ui/DashboardLink");